import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Fragment, useState, useEffect } from "react";
import { getOtherOptionsFromWindow } from "../../utils";
import { useBanner } from "../../contexts";
import { BannerBodyInlineStyles } from "./inlineStyles";
var SELECT_NONE = -1;

var BannerHistorySelect = function BannerHistorySelect() {
  var _history$;

  var banner = useBanner();

  var _useState = useState(SELECT_NONE),
      _useState2 = _slicedToArray(_useState, 2),
      selectedId = _useState2[0],
      setSelectedId = _useState2[1];

  var activeAction = banner.activeAction,
      history = banner.history,
      selectHistoryEntry = banner.selectHistoryEntry;

  var _getOtherOptionsFromW = getOtherOptionsFromWindow(),
      _getOtherOptionsFromW2 = _getOtherOptionsFromW.bannerI18n,
      historyLabel = _getOtherOptionsFromW2.historyLabel,
      historySelectNone = _getOtherOptionsFromW2.historySelectNone; // Reset select after exit history dialog


  useEffect(function () {
    if (!activeAction) {
      setSelectedId(SELECT_NONE);
    } else if (activeAction === "history" && history !== null && history !== void 0 && history.length) {
      setSelectedId(history[0].id);
    }
  }, [activeAction, history]); // History can only contain my data, so we can pick the first entry for the history

  var uuid = history === null || history === void 0 ? void 0 : (_history$ = history[0]) === null || _history$ === void 0 ? void 0 : _history$.uuid;
  return h(Fragment, null, historyLabel, "\xA0", h("select", _extends({}, BannerBodyInlineStyles.historySelect(banner), {
    disabled: !(history !== null && history !== void 0 && history.length),
    value: selectedId,
    onChange: function onChange(e) {
      var value = +e.target.value;
      history.forEach(function (_ref) {
        var id = _ref.id,
            decision = _ref.decision,
            groups = _ref.groups,
            tcf = _ref.tcf;

        if (id === value) {
          setSelectedId(id);
          selectHistoryEntry(groups, decision, tcf);
        }
      });
    }
  }), (history === null || history === void 0 ? void 0 : history.length) > 0 ? history.map(function (_ref2) {
    var id = _ref2.id,
        isDoNotTrack = _ref2.isDoNotTrack,
        isUnblock = _ref2.isUnblock,
        isForwarded = _ref2.isForwarded,
        created = _ref2.created;
    return h("option", {
      key: id,
      value: id
    }, new Date(created).toLocaleString(document.documentElement.lang), isDoNotTrack ? " (Do Not Track)" : "", isUnblock ? " (Content Blocker)" : "", isForwarded ? " (Consent Forwarding)" : "");
  }) : h("option", {
    value: SELECT_NONE
  }, historySelectNone)), !!uuid && h("div", {
    style: {
      opacity: 0.5,
      marginTop: 5
    }
  }, "UUID: ", uuid));
};

export { BannerHistorySelect };